import JoinUs from "../components/Sections/JoinUs";

export default function JoinUsPage() {
  return (
      <>
          <JoinUs />
  
      </>
  ) 
}